const endPt = {
    API_ENDPOINT: 'https://helpdeskform.azurewebsites.net:443/api/submitFormToEmail/triggers/manual/invoke?api-version=2020-05-01-preview&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yqLtKqrLqo88LI7lJWDveIcYb_3700pBrMsoUBWpbAI'
}

export default endPt